import { useEffect } from "react";
import { motion } from "framer-motion";
import retirementAssetsIllustration from "../../../static/illustration--retirement-assets.svg";
import { useAnswer } from "../../../util/form";
import { useAppStore } from "../../../store/store";

export default function ReviewResults({
  advanceScreen,
  previousScreen,
  updateValidation,
  screen,
}) {
  const { user } = useAppStore();
  const { setAnswer } = useAnswer(screen.id);

  useEffect(() => {
    // Dynamically determine the routing based on user state
    // This replaces the hardcoded "authorizedWithoutPortfolioOnTrack"
    const hasPortfolio = user.artesysPortfolioExists;
    const isAuthorized = user.isAuthorized;
    
    // Default to assuming user is on track if we reached this screen
    // The actual "on track" status should be determined by the API
    // For now, we'll route to the "on track" variant since they completed the GB flow
    let routingAnswer;
    
    if (isAuthorized && hasPortfolio) {
      // Will route to 2.9 (has portfolio on track) or 2.8 (has portfolio not on track)
      // Since we don't have isOnTrack in state yet, default to on track
      routingAnswer = "authorizedWithPortfolioOnTrack";
    } else if (isAuthorized && !hasPortfolio) {
      // Will route to 2.11 (no portfolio on track) or 2.10 (no portfolio not on track)
      routingAnswer = "authorizedWithoutPortfolioOnTrack";
    } else {
      // Fallback for non-authorized users
      routingAnswer = "authorizedWithoutPortfolioOnTrack";
    }
    
    updateAnswer(routingAnswer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function updateAnswer(value) {
    setAnswer(value);
    updateValidation(value.length > 0);
  }

  return (
    <motion.div
      className="w-full h-full"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.35 }}
    >
      <section className="w-full h-full px-6 py-16 text-center bg-white md:py-20 md:px-16">
        <div className="flex flex-col md:h-full">
          <div className="max-w-xl mx-auto">
            <img
              className="block h-auto mx-auto w-28 md:w-36"
              src={retirementAssetsIllustration}
              alt=""
            />
            <h1 className="mt-6 mb-4 text-3xl md:mb-5 md:mt-8 md:text-4xl">
              Let’s review your results
            </h1>
            <div className="max-w-xl mx-auto">
              <p>
                You’re almost done! You’ve set your retirement goals, and now
                it’s time to review your results and see how you can achieve
                them. We’ll show you a summary of your current situation, your
                projected retirement income, and some recommendations to help
                you reach your goals. Ready to see your results? Click the
                button below to continue.
              </p>
            </div>
          </div>
          <div className="flex justify-center gap-3 mt-6 md:mt-10 md:gap-5">
            <button className="btn btn--secondary" onClick={previousScreen}>
              Back
            </button>
            <button className="btn btn--primary" onClick={advanceScreen}>
              Continue
            </button>
          </div>
        </div>
      </section>
    </motion.div>
  );
}
